var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCompanyStore } from '../../application/stores/company.store';
import { FormStatus } from '../../contexts/FormProgressContext';
import { validateFormData } from '../../utils/forms/validateForm';
import { log } from '../../utils/logger';
import { ServiceFormFillingRepository } from '../repositories/serviceFormFilling.impl.repository';
import { AnswerProcessorService } from './answerProcessor.impl.service';
export class ServiceFormFillingService {
    constructor() {
        this.repository = new ServiceFormFillingRepository();
        this.answerProcessor = new AnswerProcessorService();
        this.delay = (ms) => new Promise((res) => setTimeout(res, ms));
    }
    updateFormResponses(responses, serviceFormFillingId, version) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.repository.updateFormResponses(responses, serviceFormFillingId, version);
            }
            catch (error) {
                log.error('Error actualizando respuestas', { error });
                return null;
            }
        });
    }
    getValidatedForm(serviceId, companyData, formType) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { formJson, version } = yield this.repository.getFormJson(serviceId);
                const { isValid, errors } = validateFormData(formType, formJson);
                //TODO: Si no es valido retornar un error o algo
                if (!isValid) {
                    log.debug('El json del formulario no es correcto', errors);
                }
                if (companyData.formStatus === FormStatus.NOT_CREATED) {
                    yield this.repository.createNewForm(companyData.companyId, serviceId, version);
                    useCompanyStore.getState().setFormProgressStatus(FormStatus.NOT_STARTED);
                }
                var serviceFormFillingResponse = yield this.getServiceFormFilling(companyData.companyId, serviceId);
                var answers = this.answerProcessor.transformFromFormResponse(serviceFormFillingResponse.formResponses, serviceFormFillingResponse.version);
                return {
                    form: formJson,
                    isValid,
                    serviceFormFillingId: serviceFormFillingResponse.id,
                    version,
                    answers,
                };
            }
            catch (error) {
                log.error('Error en getValidatedForm:', error);
                return {
                    form: null,
                    isValid: false,
                    version: '',
                    answers: null,
                };
            }
        });
    }
    getServiceFormFilling(companyId, serviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const raw = yield this.repository.getServiceFormFilling(companyId, serviceId);
                if (!raw) {
                    return null;
                }
                let formResponses = [];
                const formCompletionDate = raw.formCompletionDate ? new Date(raw.formCompletionDate) : undefined;
                if (raw.formResponses) {
                    const parsed = JSON.parse(raw.formResponses);
                    if (parsed && Array.isArray(parsed === null || parsed === void 0 ? void 0 : parsed.responses)) {
                        formResponses = parsed.responses;
                    }
                }
                const typed = {
                    id: raw.id,
                    companyId: raw.companyId,
                    serviceId: raw.serviceId,
                    formResponses,
                    formCompletionDate,
                    version: raw.version,
                };
                return typed;
            }
            catch (error) {
                log.error('Error obteniendo serviceFormFilling', { error });
                return null;
            }
        });
    }
    checkIsDpdMandatory(serviceFormFillingId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const isDpdMandatory = yield this.repository.checkIsDpdMandatory(serviceFormFillingId);
                return isDpdMandatory;
            }
            catch (err) {
                log.error('Excepcion calculando IsDpdMandatory', err);
                return false;
            }
        });
    }
    checkEipdResultAsync(serviceFormFillingId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                //TODO: Revisar bien este flujo
                yield this.repository.calculateEipd(serviceFormFillingId);
                let eipdResult = null;
                do {
                    yield this.delay(2000);
                    eipdResult = yield this.repository.checkIsEipdRequired(serviceFormFillingId);
                } while (eipdResult === null);
                return eipdResult;
            }
            catch (error) {
                log.error('Error obteniendo eipd obligatorio', { error });
                return false;
            }
        });
    }
    __setDelay(fn) {
        this.delay = fn;
    }
}
